import React from "react";

import Valkyrie from "@sippy-platform/valkyrie";

import { Box, Card, CardHeader, Stack, Tab, Tabs } from "@mui/material";
import PropTypes from "prop-types";

function HeaderCard({ children, tab = 0, changeTab, tabs = [], disableResponsiveTabs = false, action, sx, ...props }) {
  return (
    <Card
      elevation={4}
      sx={[
        (theme) => ({
          containerType: "inline-size",
          m: 0,
          minHeight: 60,
          position: "sticky",
          top: 0,
          zIndex: 1000,
          overflow: "hidden",
          ...theme.acrylic,
        }),
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...props}
    >
      {children ? (
        children
      ) : (
        <CardHeader
          action={
            <Stack direction="row" spacing={0.25}>
              {action}
            </Stack>
          }
          {...props}
        />
      )}
      {tabs?.length >= 1 ? (
        <Tabs value={tab} onChange={changeTab} sx={{ m: 1, mt: -0.5 }}>
          {tabs.map((_tab, key) => (
            <Tab
              key={key}
              label={
                <Box
                  sx={{
                    display:
                      tabs.length >= 4 && !_tab.disableResponsive ? { xs: "none", sm: "block" } : { xs: "block" },
                  }}
                >
                  {_tab.label}
                </Box>
              }
              icon={<Valkyrie icon={_tab.icon} />}
              id={`tab-${_tab?.id || key}`}
              disabled={_tab?.disabled}
              value={_tab?.value ?? undefined}
              sx={{
                flex: tabs.length >= 4 && !disableResponsiveTabs ? { xs: 1, sm: "initial" } : { xs: "initial" },
              }}
            />
          ))}
        </Tabs>
      ) : (
        <React.Fragment />
      )}
    </Card>
  );
}

HeaderCard.propTypes = {
  children: PropTypes.node,
  sx: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  tab: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.bool]),
  tabs: PropTypes.array,
  changeTab: PropTypes.func,
  disableResponsiveTabs: PropTypes.bool,
  action: PropTypes.node,
};

export default HeaderCard;
